export const InView = {
	init() {
		if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;

		const children = document.querySelectorAll('.entry-content > *, .pre-footer-cta-wrapper');
		if ( ! children.length ) return;

		children.forEach( el => el.classList.add( 'not-in-view' ) );

		const observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( entry => {
					if ( entry.isIntersecting ) {
						entry.target.classList.remove( 'not-in-view' );
						observer.unobserve( entry.target );
					}
				} );
			},
			{ threshold: 0.1 }
		);

		children.forEach( el => observer.observe( el ) );
	},
};
